import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const SidebarShow16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M10.4697 7.96967L11.5303 9.03033L15.0607 5.5L11.5303 1.96967L10.4697 3.03033L12.9393 5.5L10.4697 7.96967Z'
      fill='currentColor'
    />
    <path d='M15 13.25V11.75H1V13.25H15Z' fill='currentColor' />
    <path d='M8 8.74999H1V7.24999H8V8.74999Z' fill='currentColor' />
    <path d='M1 4.24999H8V2.74999H1V4.24999Z' fill='currentColor' />
  </Svg>
);

SidebarShow16.displayName = 'SidebarShow16';
export default SidebarShow16;
